import { useEffect } from 'preact/hooks';
import { getAppParams, getReportSearchParams } from '../components/app.util';
import urlUtils from '../utils/urlUtils';
import { channelEnum } from '../constants/app';

enum OpenType {
  HAI_OPEN = 'hai_open',
}
const useReport = (config, beaconAction) => {
  useEffect(() => {
    if (beaconAction && config) {
      const { userInfo } = config;
      const workspace_id = urlUtils.getSpaceKey();

      const { open_type, ...rest } = getReportSearchParams();
      const { channel, autoOpen } = getAppParams();
      // 从hai点击icon进入，非cs途径
      const openFromHai = autoOpen !== 'true' && channel === channelEnum.HAI;
      let synOpenType = open_type;
      if (openFromHai) {
        synOpenType = OpenType.HAI_OPEN;
      }

      beaconAction?.current?.onDirectUserAction('ws_open', {
        user_id: userInfo?.data?.id,
        workspace_id,
        open_type: synOpenType,
        ...rest,
      });
    }
  }, [config, beaconAction]);
};

export default useReport;
